/*
 * @format
 */

import * as actionTypes from '../action-types';

const states = {
  NOT_STARTED: 'notStarted',
  OFFLINE: 'offline',
  ONLINE: 'online',
  ABORTED: 'aborted',
};

export const initialState = { state: states.NOT_STARTED };

export const resumeRegistration = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESUME_REGISTRATION_START: {
      return { state: states.OFFLINE };
    }

    case actionTypes.RESUME_REGISTRATION_RETURN_TO_APP: {
      return {
        state: states.ONLINE,
        macAddress: action.macAddress,
        publicKey: action.publicKey,
        connectionValidAfter: action.connectionValidAfter,
      };
    }

    case actionTypes.RESUME_REGISTRATION_ABORT: {
      return {
        state: states.ABORTED,
      };
    }

    case actionTypes.RESUME_REGISTRATION_COMPLETE:
      return initialState;

    default:
      return state;
  }
};
